import { Component, Directive } from '@angular/core';

/**
 * @description
 * Template driven container for FilterChipComponent (<sales-ui-filter-chip>).
 *
 * @usageNotes
 * ### Template example of usage with template driven va filter component.
 *
 * This could be an implementation of a reusable filter bar that can be used at the app or page level.
 * ```html
 * <va-filter-2>
 *   <va-filter-toolbar>
 *     <sales-ui-filter-chip-container>
 *       <sales-ui-filter-chip *ngIf="allValuesInOneChipExample$ | async as names"
 *                    [canRemove]="true"
 *                    (clicked)="openSalespeopleSelector()"
 *                    (delete)="clearSalespeopleFilters()">
 *         <filter-chip-title>{{'COMMON.SALESPEOPLE_LABEL' | translate}}:</filter-chip-title>
 *         <filter-chip-value class="chip-value">{{names}}</filter-chip-value>
 *       </sales-ui-filter-chip>
 *       <ng-container *ngIf="chipForEachValueExample$ | async as names">
 *         <sales-ui-filter-chip *ngFor="names as name"
 *                      [canRemove]="true"
 *                      (clicked)="openSalespeopleSelector()"
 *                      (delete)="clearSalespeopleFilters()">
 *           <mat-icon>person</mat-icon>
 *           <filter-chip-value class="chip-value">{{name}}</filter-chip-value>
 *         </sales-ui-filter-chip>
 *       </ng-container>
 *       <filter-menu-items>
 *         <button (click)="openSalespeopleSelector()" mat-menu-item>{{'COMMON.SALESPEOPLE_LABEL' | translate}}...</button>
 *       </filter-menu-items>
 *     </sales-ui-filter-chip-container>
 *   </va-filter-toolbar>
 *   <va-filter-toolbar-actions>...sorting options go here...</va-filter-toolbar-actions>
 *   <va-filter-content>
 *     <ng-content><ng-content>
 *   </va-filter-content>
 * <va-filter-2>
 * ```
 */
@Component({
  selector: 'sales-ui-filter-chip-container',
  templateUrl: './filter-chip-container.component.html',
  styleUrls: ['./filter-chip-container.component.scss'],
})
export class FilterChipContainerComponent {}

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'filter-menu-items',
})
export class FilterMenuItemsDirective {}

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'filter-chip-actions',
})
export class FilterChipActionsDirective {}
